import { createRoot } from '../../utils/react-shim'

import { ContactForm } from '../ContactForm'

export class ContactFormElement extends HTMLElement {
  connectedCallback() {
    const root = createRoot(this)
    root.render(<ContactForm />)
  }
}
